import { BroadcastScheludeHeaderDeliveryFilter } from './BroadcastScheludeHeaderDeliveryFilter/BroadcastScheludeHeaderDeliveryFilter';
import { BroadcastScheludeHeaderNumberFilter } from './BroadcastScheludeHeaderNumberFilter/BroadcastScheludeHeaderNumberFilter';
import { BroadcastScheludeHeaderSeenFilter } from './BroadcastScheludeHeaderSeenFilter/BroadcastScheludeHeaderSeenFilter';

type BroadcastScheduleHeaderFiltersProps = {
  isAudiencesMode: boolean;
};

export function BroadcastScheduleHeaderFilters({
  isAudiencesMode,
}: BroadcastScheduleHeaderFiltersProps) {
  return (
    <div className="flex flex-wrap items-center gap-4">
      <BroadcastScheludeHeaderNumberFilter />

      {!isAudiencesMode && (
        <>
          <BroadcastScheludeHeaderDeliveryFilter />
          <BroadcastScheludeHeaderSeenFilter />
        </>
      )}
    </div>
  );
}
